import { SeCommonConfig } from './SeCommonConfig.class';
import { ICssShadow } from './ICssShadow.interface';
import { Subject } from 'rxjs/Subject';
import { HostListener, HostBinding, Renderer2, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import * as _ from 'lodash';
import { IAnimation } from './ianimation.interface';
import { AnimationBuilder } from 'css-animator';

declare var Matrix;

/**
 *Common functions and properties to all screen elements
 *
 * @export
 * @class ScreenElement
 */
export class ScreenElementClass {
  // settings for this element
  public elementConfig: SeCommonConfig;

  public aspectRatioLocked: boolean;
  public movementLocked: boolean;
  public elementRef;
  public sanitizer: DomSanitizer;
  public currentThumbnail: any;

  public renderer: Renderer2;

  // animation vars
  public animator: AnimationBuilder;
  public currentPlayingAnimation: IAnimation;

  // publish local events
  public onMouseOverSubject: Subject<any> = new Subject<any>();
  public onMouseLeaveSubject: Subject<any> = new Subject<any>();
  public onMouseDownSubject: Subject<any> = new Subject<any>();
  public onClickSubject: Subject<any> = new Subject<any>();
  public onTouchStartSubject: Subject<any> = new Subject<any>();
  public onTouchMoveSubject: Subject<any> = new Subject<any>();
  public onTouchEndSubject: Subject<any> = new Subject<any>();
  public onScrollSubject: Subject<any> = new Subject<any>();
  public onElementReadySubject: Subject<any> = new Subject<any>();

  public singleAnimationFinished: EventEmitter<IAnimation> = new EventEmitter();
  public allAnimationsFinished: EventEmitter<Array<IAnimation>> = new EventEmitter();


  @HostBinding('class.screen-element') true; // mark this html elemnt as a screen element
  @HostBinding('attr.data-uniqueid') get getUniqueId() { return this.elementConfig.uniqueId; }
  @HostBinding('style.position') position = 'absolute';

  // use the positon attributs from the settings.. may be to slow
  // the other option is to set these directly fromt he parent design surface or adorner
  // in that case the properties will set in the config for serialization only, the real vals
  // would be applied directly to the element

  @HostBinding('style.width') get getWidth() { return this.elementConfig.width + 'px'; }
  @HostBinding('style.height') get getHeight() { return this.elementConfig.height + 'px'; }
  @HostBinding('style.opacity') get getOpacity() { return this.elementConfig.opacity; }

  // border props
  @HostBinding('style.border-width') get getBorderWidth() { return this.elementConfig.borderWidth + 'px'; }
  @HostBinding('style.border-color') get getBorderColor() { return this.elementConfig.borderColor; }
  @HostBinding('style.border-style') get getBorderStyle() { return this.elementConfig.borderStyle; }
  @HostBinding('style.border-radius') get getBorderRadius() { return this.elementConfig.borderRadius + 'px'; }

  //  @HostBinding('style.overflow') get getOverflow() { return 'hidden'; } // set overflow hidden (makes border radius look right)
  // but causes problems other places... like animations do not display outside of box

  // zindex
  @HostBinding('style.z-index') get getZindex() { return this.elementConfig.zIndex; } // set z index position

  // box shadows
  @HostBinding('style.box-shadow') get geBoxShadows() {
    // build box shadow string with all the shadows
    let shadowStr = '';
    if (this.elementConfig.boxShadows.length > 0) {
      this.elementConfig.boxShadows.forEach((shadow: ICssShadow) => {
        shadowStr += `${shadow.x}px ${shadow.y}px ${shadow.blur}px ${shadow.spread}px ${shadow.color}, `;
      });
      shadowStr = shadowStr.substring(0, shadowStr.length - 2); // remove last commma
    }
    return this.sanitizer.bypassSecurityTrustStyle(shadowStr);
  }

  // transform props
  @HostBinding('style.transform') get getTransform() {
    // const matrix = new Matrix();
    // matrix.setTransform(1, 0, 0, 1, 0, 0);

    // matrix.translate(this.elementConfig.position.x, this.elementConfig.position.y);


    // matrix.rotateDeg(this.elementConfig.rotation);


    // this.t.a = matrix.a; // scale x
    // this.t.b = matrix.b; // skew y
    // this.t.c = matrix.c; // skew x
    // this.t.d = matrix.d; // scale y
    // this.t.e = matrix.e; // translate x
    // this.t.f = matrix.f; // translate y

    // const safestyle = this.sanitizer.bypassSecurityTrustStyle(`
    //   matrix(${matrix.a}, ${matrix.b}, ${matrix.c}, ${matrix.d}, ${matrix.e}, ${matrix.f})
    // `);


    const safestyle = this.sanitizer.bypassSecurityTrustStyle(`
      translateX(${this.elementConfig.position.x}px)
      translateY(${this.elementConfig.position.y}px)
      rotate(${this.elementConfig.rotation}deg)
      rotateX(${this.elementConfig.rotation3d.x}deg)
      rotateY(${this.elementConfig.rotation3d.y}deg)
    `);


    // const safestyle = this.sanitizer.bypassSecurityTrustStyle(`
    //     rotate(${this.elementConfig.rotation + this.elementConfig.flip}deg)
    //     rotateX(${this.elementConfig.rotation3d.x}deg)
    //     rotateY(${this.elementConfig.rotation3d.y}deg)
    //   `);


    return safestyle;
  }

  // @HostBinding('style.top') get getTop() {
  //   const matrix = new Matrix();
  //   matrix.setTransform(1, 0, 0, 1, 0, 0);
  //   matrix.rotateDeg(this.elementConfig.rotation);
  //   const ohgt = this.elementConfig.height * 1 / matrix.d;
  //   const scaleY =  (this.elementConfig.height / ohgt);
  //   const adder = this.elementConfig.height *  (1 - scaleY);

  //   const diff = ohgt - this.elementConfig.height;
  //   return (this.elementConfig.position.y)  + 'px';
  // }

  // @HostBinding('style.left') get getLeft() {
  //   const matrix = new Matrix();
  //   matrix.setTransform(1, 0, 0, 1, 0, 0);
  //   matrix.rotateDeg(this.elementConfig.rotation);
  //   const owid = this.elementConfig.width * 1 / matrix.a;
  //   const scaleX =  (this.elementConfig.position.x / owid);
  //   const adder = this.elementConfig.width  * (1 - scaleX);
  //   return (this.elementConfig.position.x) + 'px';
  // }


  constructor(sanitizer: DomSanitizer) {
    this.sanitizer = sanitizer; // get dom sanitizer from child constructor

  }

  flipRight() {
    this.elementConfig.flip += 90;
    if (this.elementConfig.flip >= 360) {
      this.elementConfig.flip = 0;
    }

    // set original sizes to match new flip
    this.elementConfig.originalSize.width = this.elementConfig.width;
    this.elementConfig.originalSize.height = this.elementConfig.height;
  }

  flipLeft() {
    this.elementConfig.flip -= 90;
    if (this.elementConfig.flip < 0) {
      this.elementConfig.flip = 270;
    }

    // set original sizes to match new flip
    this.elementConfig.originalSize.width = this.elementConfig.width;
    this.elementConfig.originalSize.height = this.elementConfig.height;
  }

  unFlip() {
    this.elementConfig.flip = 0;

    // set original sizes to match new flip
    this.elementConfig.originalSize.width = this.elementConfig.width;
    this.elementConfig.originalSize.height = this.elementConfig.height;
  }


  async playAnimations() {
    const animationList = (<Array<IAnimation>>this.elementConfig.animations).slice(); // get shadow list copy

    for (const animation of animationList) {

      await this.playAnimation(animation);
    }

    this.allAnimationsFinished.emit(animationList);
  }

  async playAnimation(animation: IAnimation) {

    this.currentPlayingAnimation = animation;

    this.animator = new AnimationBuilder();
    this.animator.setOptions({
      type: animation.name,
      duration: animation.duration,
      pin: false,
      fixed: true,
      iterationCount: animation.interations,
      delay: animation.delay
    });

    const element = this.elementRef.nativeElement.children[0];

    await this.animator.animate(element);
    this.singleAnimationFinished.emit(animation);
    this.currentPlayingAnimation = null;

  }

  async stopAnimation() {
    const element = this.elementRef.nativeElement.children[0];

    if (this.animator) {
      this.animator.stop(element);
    }


    this.singleAnimationFinished.emit(this.currentPlayingAnimation);
    this.currentPlayingAnimation = null;
  }

  timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  getMinimumScheduleTime(): number {
    // calculate the total time (in seconds this screen needs to play)
    let totalTime = 0;

    // add screenTime (set by the element itself)
    totalTime += this.elementConfig.screenTime;

    // add animations
    for (const ani of <Array<IAnimation>>this.elementConfig.animations) {
      const dur = ani.duration ? ani.duration : 1000; // default duration of 1 sec if not specified (to make backwards compatible)
      totalTime += (dur * ani.interations) / 1000;
    }

    return totalTime;
  }

  getHtml(): string {
    // get html of element
    const elementCopy = this.elementRef.nativeElement.cloneNode(true);
    const ss = document.styleSheets; // get all the style sheets

    // this.computedStyleToInlineStyle(elementCopy, true);  // this doesnt work for all style types :(  .. looks like we do it the hard way!

    // hard way... build style rule list but only for screen elements
    // looks for dummy style rule '.se-element'
    let cssStr = '<style>';
    cssStr += 'img { width: 100%; height: 100%; } body { margin: 0;}'; // add global styles for any element
    for (let index = 0; index < ss.length; index++) {
      const s: any = ss[index];
      if (ss.hasOwnProperty('cssRules')) {
        if (_.get(s, 'rules[0].cssText', false) && s.rules[0].cssText.indexOf('se-element') > -1) {
          // add them to the style text
          for (let index2 = 0; index2 < s.rules.length; index2++) {
            const st = s.rules[index2];
            cssStr += st.cssText;
          }
        }
      }
    }
    cssStr += '</style>'; // close style tag

    let htmlWithStyle = cssStr +  '' + elementCopy.innerHTML + ''; // construct final html string
    htmlWithStyle = htmlWithStyle.split('transform:').join('-webkit-transform:'); // change trnasforms to webkit compatable versions

    // use place holders for video

    if (['SeVideo', 'SeLiveVideo', 'SeVideo'].indexOf(this.elementConfig.SeType)) {
      // replace video with img of poster
      htmlWithStyle = htmlWithStyle.replace(/<vg-player [\s\S]*?<\/vg-player>/, `<img src=${this.elementConfig.poster}> style="height: 100%; width: 100%;"`);
    }

    return htmlWithStyle;
  }

  // publish mouse events so we can activate the adorner
  @HostListener('mouseenter', ['$event'])
  onMouseOver(e: MouseEvent) {
    this.onMouseOverSubject.next({
      componentRef: this,
      nativeElement: this.elementRef.nativeElement,
      event: e
    });
  }

  @HostListener('mouseout', ['$event'])
  onMouseLeave(e: MouseEvent) {
    this.onMouseLeaveSubject.next({
      componentRef: this,
      nativeElement: this.elementRef.nativeElement,
      event: e
    });
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(e: MouseEvent) {
    this.onMouseDownSubject.next({
      componentRef: this,
      nativeElement: this.elementRef.nativeElement,
      event: e
    });
  }

  @HostListener('click', ['$event'])
  onClick(e: MouseEvent) {
    this.onClickSubject.next({
      componentRef: this,
      nativeElement: this.elementRef.nativeElement,
      event: e
    });
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(e: any) {
    this.onTouchStartSubject.next({
      componentRef: this,
      nativeElement: this.elementRef.nativeElement,
      event: e
    });
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(e: any) {
    this.onTouchMoveSubject.next({
      componentRef: this,
      nativeElement: this.elementRef.nativeElement,
      event: e
    });
  }


  @HostListener('touchend', ['$event'])
  onTouchEnd(e: any) {
    this.onTouchEndSubject.next({
      componentRef: this,
      nativeElement: this.elementRef.nativeElement,
      event: e
    });
  }

  @HostListener('wheel', ['$event'])
  onScroll(e: any) {
    this.onScrollSubject.next({
      componentRef: this,
      nativeElement: this.elementRef.nativeElement,
      event: e
    });
  }


  gcCleanup() {
    // called on component destroy to help the gc find unused objects
    // const that = this;
    // Object.keys(this).map(k => {
    //   if (k !== 'vgapi') {
    //     that[k] = null;
    //   } else {
    //     k = k;
    //   }

    // });

    // clear element config for gc
    if (this.elementConfig) {
      Object.keys(this.elementConfig).map(k => {
        this.elementConfig[k] = null;
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/screen-element.class.ts